import {ready} from "../utils/ready.mjs";

;(function () {
    'use strict';

    // init main navigation
    ready(function () {
        const tooltips = document.querySelectorAll('.js-tooltip');
        if (tooltips.length > 0) {
            Array.prototype.forEach.call(tooltips, function (tooltip) {
                const tt = new Tooltip(tooltip);
            });
        }
    });

    // Constructor
    function Tooltip(tooltip)
    {
        const self = this;

        self.trigger = tooltip;
        self.targetid = self.trigger.getAttribute('aria-labelledby');

        if (self.targetid) {
            self.target = document.getElementById(self.targetid);
            if (typeof(self.target) != 'undefined' && self.target != null) {

                self.trigger.addEventListener('click', function (e) {
                    e.preventDefault();
                    self.toggle();
                }.bind(self))

                self.outsideClick = function (e) {
                    if (this.target.classList.contains('js-tooltip-show') && !this.trigger.parentNode.contains(e.target)) {
                        this.close();
                    }
                }
                document.addEventListener('click', this.outsideClick.bind(this));
            }
        }

        // initiate listeners object for public events
        self._listeners = {}
    }

    // Close methods
    Tooltip.prototype.close = function () {
        // add class to hide tooltip
        this.target.classList.remove('js-tooltip-show');
        // fire close event
        this._fire('close');
        return this;
    }

    Tooltip.prototype.open = function () {
        // add class to hide tooltip
        this.target.classList.add('js-tooltip-show');
        // fire close event
        this._fire('open');
        return this;
    }

    Tooltip.prototype.toggle = function () {
        let open = this.target.classList.contains('js-tooltip-show');
        return open ? this.close() : this.open();
    }

    Tooltip.prototype._fire = function (type, data) {
        if (typeof this._listeners === 'undefined') {
            this._listeners = [];
        }
        var listeners = this._listeners[type] || [];
        listeners.forEach(function (listener) {
            listener(data);
        })
    }

    Tooltip.prototype.on = function (type, handler) {
        if (typeof this._listeners[type] === 'undefined') {
            this._listeners[type] = [];
        }
        this._listeners[type].push(handler);
        return this;
    }

    Tooltip.prototype.off = function (type, handler) {
        const index = this._listeners[type].indexOf(handler);
        if (index > -1) {
            this._listeners[type].splice(index, 1);
        }
        return this;
    }

    // Export PasswordField
    if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
        module.exports = Tooltip;
    } else if (typeof define === 'function' && define.amd) {
        define('Tooltip', [], function () {
            return Tooltip;
        })
    } else {
        // attach to window
        window.Tooltip = Tooltip;
    }
}());
